import withViewportPopup from './with-viewport-popup';

export default withViewportPopup;
